var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCard)?_c('CardLayout',{attrs:{"title":_vm.$lang('¿Cómo realizo el pago?')}},[(_vm.componentName)?_c(_vm.componentName,{tag:"component",attrs:{"order":_vm.order}}):_vm._e(),(this.payment.expirationTime)?_c('div',{staticClass:"font-1",domProps:{"innerHTML":_vm._s(
			_vm.$lang(
				'Te solicitamos que <b>realices el pago dentro de las {time} hs.</b> de haber confirmado tu compra. Luego de ese plazo tu orden será cancelada.',
				{ time: String(this.payment.expirationTime) }
			)
		)}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }